import { type ReactNode } from 'react';

/**
 * True for nodes that render nothing (`null`, `undefined`, `''`, booleans, or an array of those) —
 * so an "empty" slot can be left out of the DOM instead of rendering a wrapper that only adds gap.
 */
export const isEmptyNode = (node: ReactNode): boolean =>
  node == null || node === '' || typeof node === 'boolean' || (Array.isArray(node) && node.every(isEmptyNode));
